module.exports = __webpack_public_path__ + "img/cf5a7a8.jpg";